'use strict';

if (!global.Promise) global.Promise = require('promise-polyfill');
if (!global.fetch) global.fetch = require('isomorphic-unfetch');


// WEBPACK FOOTER //
// ../node_modules/preact-cli/lib/lib/webpack/polyfills.js